// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pagenav":"pagenav-2mhSA","outer":"outer-3GTby","current":"current-3qRSb","pagehit":"pagehit-8gyP-"};